import { render, staticRenderFns } from "./AdminInterliningsEditScreen.vue?vue&type=template&id=39af17d1&scoped=true&"
import script from "./AdminInterliningsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminInterliningsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af17d1",
  null
  
)

export default component.exports